import { StubPage } from '../StubPage'
export function ApiKeys() {
  return <StubPage title="API Keys" summary="API Keys allow external services and scripts to call Rabbit APIs without interactive login. Keys are scoped to a business and carry the same role-based permissions as regular users." />
}
